import activities from '@/components/Dashboard/RecentActivities.vue';
<template>
  <b-modal :active.sync="isModalActive" has-modal-card>
    <div class="modal-card">
      <header class="modal-card-head">
        <h1 class="is-title-header modal-card-title">
          Filter Dashboard activities 2
        </h1>
      </header>
      <section class="modal-card-body">
        <div class="columns">
          <div class="column">
            <b-field label="Customer name">
              <b-select
                name="customer_name"
                expanded
                v-model="searchCustomer"
                required
                placeholder="Please select"
              >
                <option
                  v-for="(option, index) in customers"
                  :value="option.id"
                  :key="index"
                >
                  {{ option.name }}
                </option>
              </b-select>
            </b-field>

            <b-field label="User">
              <b-select
                name="user"
                expanded
                v-model="searchUser"
                required
                placeholder="Please select"
              >
                <option selected></option>
                <option
                  v-for="(option, index) in users"
                  :value="option.id"
                  :key="index"
                  :hidden="option.is_active == false"
                >
                  {{ option.name }}
                </option>
              </b-select>
            </b-field>

            <b-field label="from">
              <b-datepicker
                name="from_date"
                required
                v-model="searchFromDate"
                icon="calendar-today"
                trap-focus
              >
                <b-button type="is-danger" @click="searchFromDate = null">
                  <b-icon icon="close"></b-icon>
                  <span>Clear</span>
                </b-button>
              </b-datepicker>
            </b-field>
            <b-field label="to">
              <b-datepicker
                name="to_date"
                required
                v-model="searchToDate"
                icon="calendar-today"
                trap-focus
              >
                <b-button type="is-danger" @click="searchToDate = null">
                  <b-icon icon="close"></b-icon>
                  <span>Clear</span>
                </b-button>
              </b-datepicker>
            </b-field>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <b-button slot="right" type="is-primary" @click="submit">
          Apply
        </b-button>
        <b-button slot="right" type="is-danger" @click="cancel">
          Abort
        </b-button>
      </footer>
    </div>
  </b-modal>
</template>
<script>
import CustomerProfileDataService from "../../services/CustomerProfileDataService";
import UserDataService from "../../services/UserDataService";
import scopeMixin from "@/mixins/scopeMixin";
// @group Dashboard
export default {
  mixins: [scopeMixin],
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    allUsers: {
      type: Array,
      default() {
        return [];
      }
    },
    allCustomers: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      customerDataService: new CustomerProfileDataService(),
      userDataService: new UserDataService(),
      workflow_status: null,
      isModalActive: false,
      searchCustomer: "",
      searchUser: "",
      searchFromDate: null,
      searchToDate: null,
      customers: [],
      users: this.allUsers
    };
  },
  watch: {
    allUsers(newVal) {
      this.users = newVal;
    },
    allCustomers(newVal) {
      this.customers = newVal;
    },
    isActive(newVal) {
      this.isModalActive = newVal;
    },
    isModalActive(newValue) {
      if (!newValue) {
        this.cancel();
      }
    }
  },
  methods: {
    submit() {
      this.$emit(
        "confirm",
        this.searchCustomer,
        this.searchUser,
        this.searchFromDate,
        this.searchToDate
      );
    },
    cancel() {
      this.$emit("cancel");
    }
  }
};
</script>
